import { BlogSection } from "@/types/blog";

export const beziehung: BlogSection = {
  id: "beziehung-vor-steuerung",
  title: "Beziehung vor Steuerung",
  content: `
    <p>Früher wurden Aufgaben verteilt.<br/>
    Heute werden Beziehungen gestaltet.</p>

    <p>Gerade in serviceorientierten Bereichen wird deutlich, dass Empathie nicht ersetzbar ist. Kunden spüren sofort, ob ihnen jemand wirklich zuhört oder nur ein Skript abarbeitet.</p>

    <p>Dass viele Unternehmen wieder stärker Menschen einstellen statt ausschließlich zu automatisieren, ist kein Rückschritt. Es ist eine bewusste Entscheidung für Qualität von Beziehung.</p>

    <p>Gute Führungskräfte investieren deshalb Zeit in Gespräche. Nicht zusätzlich, sondern als Kern ihrer Arbeit.</p>
  `
};
